import {
  collapseMarkerBackedSelectionIDs,
  stripLegacyNamespacedChoiceValues,
  type RawContextMarker,
} from '../../../helpers/visibleContext';

// Chip prompts append `<ctx:KEY=VALUE>` markers so the agent can route without
// the user re-supplying ids. They're for the LLM — strip them from the bubble
// and surface a quiet "+N key" hint instead.
const CTX_MARKER_RE = /\s*<ctx:([a-z_][a-z0-9_]*)=([^>]*)>\s*/gi;

// Clarify submit markers duplicate choices already shown as human labels in
// the bubble, and their hints are non-interactive. Strip them like any marker,
// but don't render noisy "+N fields" / "+N choice" chips. Typed destination
// markers (job, project, flow, …) remain visible as quiet context hints.
const SILENT_MARKER_KEYS = new Set(['fields', 'choice', 'action']);

interface CtxMarker {
  key: string;
  count: number;
}

export const splitUserContent = (
  raw: string
): { visible: string; markers: CtxMarker[] } => {
  const markers: CtxMarker[] = [];
  const rawMarkers: RawContextMarker[] = [];
  let visible = raw.replace(CTX_MARKER_RE, (_, key: string, value: string) => {
    const normalized = key.toLowerCase();
    rawMarkers.push({ key: normalized, value });
    if (SILENT_MARKER_KEYS.has(normalized)) return '';
    const items = value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    markers.push({ key: normalized, count: items.length });
    return '';
  });
  visible = collapseMarkerBackedSelectionIDs(visible, rawMarkers);
  visible = stripLegacyNamespacedChoiceValues(visible).trim();
  return { visible, markers };
};
